'use strict';

const kdContextError = require('./kd-context');

/**
 * Authorization Error
 *
 * This error denotes an Authorization Error, usually thrown if
 * an authenticated client does not have sufficient permissions or is
 * otherwise forbidden to proceed with some operation.
 *
 * If `context` is provided, it should contain information relevant to
 * the failed authorization attempt (attempted operation, expected permission)
 *
 * @param {string} message - Error message
 * @param {Object} detail - Error detail message
 * @param {Object} [context] - Authorization context
 */
class AuthorizationError extends kdContextError {
    constructor(message, detail, context) {
        super(message, detail, context);
        this.name = 'AuthorizationError';
        this.status = 403;
    }
}

module.exports = AuthorizationError;



/** WEBPACK FOOTER **
 ** ./src/common/error/authorization.js
 **/